import api from '../api/blackWhiteListApi';
import { AddressItem, BlackWhiteListItem } from '../types/blackWhiteListItemType';


export async function findAddress(data: string): Promise<AddressItem[]> {
    const result = await api.findAddress(data);
    return result.data;
}

export async function getBlackWhiteList(): Promise<BlackWhiteListItem[]> {
    const result = await api.getBlackWhiteList();
    return result.data;
}

export async function saveBlackWhiteList(data: BlackWhiteListItem) : Promise<string> {
    return await api.saveBlackWhiteList(data);
}

export async function addToBlackList(data: BlackWhiteListItem) : Promise<boolean> {
    return await api.addToBlackList(data);
}

export async function addToWhiteList(data: BlackWhiteListItem) : Promise<boolean> {
    return await api.addToWhiteList(data);
}

export async function deleteFromBlackList(id: string) : Promise<boolean> {
    return await api.deleteFromBlackList(id);
}

export async function toggleBlackList(id: string) : Promise<string> {
    return await api.toggleBlackList(id);
}